import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Phone, ArrowLeft, Users, Search, BookOpen, FileCheck } from 'lucide-react';
import { FaWhatsapp, FaWaze, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import ProcessSteps from '../components/ProcessSteps';
import ExpertiseAreas from '../components/ExpertiseAreas';
import ReasonsList from '../components/ReasonsCard';
import ReviewsSlider from '../components/Reviews';
import ContactButton from '../components/ContactButton';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  
  const expertiseRef = useRef(null);

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 [background-image:repeating-linear-gradient(60deg,rgba(53,67,78,0.1),rgba(53,67,78,0.1)_1px,transparent_1px,transparent_30px)] [background-size:60px_60px]">
      <div className="relative min-h-[600px] lg:min-h-[800px] overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-full">
          <img 
            src="/אראלחןיושביםראשי.jpg"
            alt="עו״ד אראל"
            className="w-full h-full object-cover animate-ken-burns"
            style={{ objectPosition: 'center 30%' }}
          />
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#97a9b6]/80 to-[#35434e]/80" />
        </div>

        {/* Content */}
        <div className="relative max-w-6xl mx-auto px-4 h-full py-20">
          <div className="flex flex-col justify-center h-full">
            <div className="text-white space-y-8 max-w-3xl text-center md:text-right">
              <h1 className="text-4xl lg:text-5xl font-bold mb-8 animate-fade-in">
                משרד עורכי דין -מיכלסון דותן ושות
              </h1>
              <p className="text-xl lg:text-2xl mb-12 animate-slide-up">
              מתמחים בחדלות פרעון והוצאה לפועל, נזיקין ואזרחי ונדל"ן
              </p>
              
              <div className="flex flex-wrap justify-center md:justify-start gap-6 animate-fade-in-up">
                <a 
                  href="tel:0532788686" 
                  className="bg-white/20 backdrop-blur-md text-white px-6 lg:px-8 py-4 rounded-xl font-medium 
                           hover:bg-white/30 transition duration-300 flex flex-col items-center
                           transform hover:scale-105"
                >
                  <Phone className="w-6 lg:w-8 h-6 lg:h-8 text-white group-hover:scale-110 transition-transform duration-300" />
                </a>
                <a 
  href="https://wa.me/972532788686" 
  target="_blank" 
  rel="noopener noreferrer"
  className="bg-white/20 backdrop-blur-md text-white px-6 lg:px-8 py-4 rounded-xl font-medium 
           hover:bg-white/30 transition duration-300 flex flex-col items-center
           transform hover:scale-105"
>
  <FaWhatsapp className="w-6 lg:w-8 h-6 lg:h-8 text-white group-hover:scale-110 transition-transform duration-300" />
</a>
                
                <a 
                  href="mailto:office@mdc-lawfirm.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white/20 backdrop-blur-md text-white px-6 lg:px-8 py-4 rounded-xl font-medium 
                           hover:bg-white/30 transition duration-300 flex flex-col items-center
                           transform hover:scale-105"
                >
                  <FaEnvelope className="w-6 lg:w-8 h-6 lg:h-8 text-white group-hover:scale-110 transition-transform duration-300" />
                </a>
                
                <a 
                  href="https://waze.com/ul?ll=31.9850714,34.7701406&navigate=yes" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white/20 backdrop-blur-md text-white px-6 lg:px-8 py-4 rounded-xl font-medium 
                           hover:bg-white/30 transition duration-300 flex flex-col items-center
                           transform hover:scale-105"
                >
                  <FaWaze className="w-6 lg:w-8 h-6 lg:h-8 text-white group-hover:scale-110 transition-transform duration-300" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref={expertiseRef}>
        <ExpertiseAreas />
      </div>
      
      <ProcessSteps />
      <ReasonsList />
  
      <div className="container mx-auto px-4">
        <ReviewsSlider 
          showTitle={true}
          title="לקוחות ממליצים"
        />
      </div>

      <div className="bg-gray-100 py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6 md:mb-8">קצת עלינו</h2>
          <p className="text-lg leading-relaxed text-gray-700">
            מיכלסון דותן ושות מתמחה במגוון תחומי המשפט האזרחי, עם דגש מיוחד על הוצאה לפועל וחדלות פירעון, דיני נזיקין ונדל"ן. 
            המשרד שם דגש על מתן שירות אישי ומקצועי, תוך שמירה על סטנדרטים גבוהים של מקצועיות ואתיקה. 
            אנו מאמינים כי כל לקוח ראוי ליחס אישי וליווי מקצועי צמוד, ופועלים ללא לאות להשגת התוצאות הטובות ביותר עבור לקוחותינו.
          </p>
        </div>
      </div>
      
      <ContactButton />
    </div>
  );
};

export default HomePage;